// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"419":"95d05f63","534":"338f5b23","560":"495479ba"}[chunkId] + ".chunk.css";
};